import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { InfluencerCampaignStatus } from '../../../../../models/influencer-campaign';

@Component({
  selector: 'campaign-influencer-status-slider',
  templateUrl: './campaign-influencer-status-slider.component.html',
  styleUrls: ['./campaign-influencer-status-slider.component.scss']
})
export class CampaignInfluencerStatusSliderComponent implements OnChanges {
  @Input() slider: InfluencerCampaignStatus[];
  @Output() changeStatus = new EventEmitter<any>();
  @Input() readonly = false;
  public currentStatus = new InfluencerCampaignStatus();

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.updateCurrentStatus();
  }

  private updateCurrentStatus() {
    if (Array.isArray(this.slider)) {
      this.slider.forEach(item => {
        if (item.selected) {
          this.currentStatus = item;
        }
      });
    }
  }

  public change(event) {
    if (this.readonly) {
      return;
    }
    this.changeStatus.emit(event);
    this.slider.forEach(item => {
      if (item.selected) {
        item.selected = false;
      }
    });
    event.selected = true;
    this.currentStatus = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-campaign-activity/campaign-influencer-status-slider/campaign-influencer-status-slider.component.ts